import { useEffect, useState } from "react";
import PageLayout from "../../components/PageLayout/PageLayout";
import { useAppDispatch } from "../../hooks";
import "./Consent.scss";
import { useDispatch, useSelector } from "react-redux";
import { updateUser, logout } from "../../store/actions/user";
import topBg01 from "./img/top-bg-01.png";
import topBg02 from "./img/top-bg-02.png";
import {
  useForm,
  SubmitHandler,
  FieldValues,
  FieldErrors,
  Controller,
} from "react-hook-form";
import { getUser } from "../../store/reducers/user";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../../components/Button/Button";

function Consent() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const user = useSelector(getUser);
  const { ident } = useParams();
  const {
    register,
    setValue,
    handleSubmit,
    getValues,
    reset,
    formState: { errors },
  } = useForm();
  const formValues = getValues();

  const [consent, setConsent] = useState(true);
  const [step, setStep] = useState(0);

  const onSubmit = (data: FieldValues) => {
    dispatch(
      updateUser(
        {
          user: {
            [`${ident}`]: consent,
          },
        },
        true,
        navigate
      )
    );
  };

  const onError = (errors: FieldErrors) => {
    //console.log(errors)
  };

  return (
    <PageLayout>
      <div className="page Consent">
        {step === 0 && (
          <div className="consent-inner step-0">
            <div className="image">
              <img src={topBg01} alt="Consent" />
            </div>
            <h2>Witaj w nowej edycji programu! </h2>
            <p className="description">
              <strong>Chcesz wziąć udział w edycji 2025?</strong> Oto kilka
              ważnych rzeczy, które warto wiedzieć przed zaakceptowaniem
              regualminu.
            </p>
            <div className="list">
              <div className="list-item">
                <span className="number">1</span>
                <p>
                Jeśli klikniesz „Akceptuję”, to Twoje dane z poprzedniej edycji wykorzystamy też w tej nowej.  W szczególności, wykorzystamy następujące kategorie danych: Dane konta, Dane osobowe, Dane&nbsp;PIT&nbsp;i&nbsp;Dane do wypłat.
                </p>
              </div>
              <div className="list-item">
                <span className="number">2</span>
                <p>Twoje poprzednie konto będzie działać jak dawniej.</p>
              </div>
              <div className="list-item">
                <span className="number">3</span>
                <p>Dane będą przetwarzane w celu realizacji programu, w tym kontaktu, realizacji nagród oraz ich rozliczenia. </p>
              </div>
            </div>

            {/* <div className="checkbox-item checkbox-item-consent">
           <div
             className="label-text"
             onClick={() => {
               setConsent(!consent);
             }}
           >
             Akceptuję warunki Programu określone w Regulaminie Programu*
           </div>
           <input type="checkbox" id="consent" defaultChecked={false} />
           <label
             onClick={() => {
               setConsent(!consent);
             }}
             htmlFor={"consent"}
             className={consent ? "check active" : "check"}
           >
             {consent ? "Tak" : "Nie"}
           </label>
         </div> */}
            {/* <p>
           Wyrażam zgodę na przetwarzanie moich danych osobowych przez British
           American Tobacco Polska Trading sp. z o.o. z&nbsp;siedzibą
           w&nbsp;Warszawie (BAT) w celu przesyłania mi informacji na temat
           produktów i&nbsp;usług oferowanych przez BAT.
         </p> */}
            {/* <p>Jako formę kontaktu wybieram:</p> */}
            {/* <div className="checkbox-item checkbox-item-marketing">
           <div
             className="label-text"
             onClick={() => {
               setEmailContact(!emailContact);
             }}
           >
             wiadomości przesyłane drogą elektroniczną (e-mail, SMS, serwisy
             internetowe, okienka pop up)
           </div>
           <input
             type="checkbox"
             id="emailContact"
             defaultChecked={user?.emailContact}
           />
           <label
             onClick={() => {
               setEmailContact(!emailContact);
             }}
             htmlFor={"emailContact"}
             className={emailContact ? "check active" : "check"}
           >
             {emailContact ? "Tak" : "Nie"}
           </label>
         </div> */}
            {/* <div className="checkbox-item checkbox-item-marketing">
           <div
             className="label-text"
             onClick={() => setPhoneContact(!phoneContact)}
           >
             połączenia głosowe (rozmowy telefoniczne, komunikaty IVR)
           </div>
           <input
             type="checkbox"
             id="phoneContact"
             defaultChecked={user?.phoneContact}
           />
           <label
             onClick={() => setPhoneContact(!phoneContact)}
             htmlFor={"phoneContact"}
             className={phoneContact ? "check active" : "check"}
           >
             {phoneContact ? "Tak" : "Nie"}
           </label>
         </div> */}
            {/* <p>
           * Zgoda konieczna do wzięcia udziału w Programie. <br />
           <br />
           Wycofanie zgody nie będzie miało jednak wpływu na zgodność
           z&nbsp;prawem naszych działań podjętych jeszcze przed jej
           wycofaniem.Więcej informacji o&nbsp;tym, jakie dane zbieramy,
           w&nbsp;jakim celu oraz do czego je wykorzystujemy znajdziesz{" "}
           <a
             href="https://www.hurt.batpartners.pl/pdf/klauzula_informacy_na_bp_hurt.pdf"
             target="_blank"
             rel="noopener noreferrer"
           >
             w&nbsp;Klauzuli Informacyjnej
           </a>
           .
         </p> */}
            <h3 className="join-copy">Dołączysz do nowej edycji?</h3>
            <div className="btn-group">
              <Button
                className="outline"
                onClick={() => {
                  setStep(1);
                }}
              >
                Odrzuć
              </Button>
              <Button onClick={handleSubmit(onSubmit, onError)}>
                Akceptuję i kontynuuję
              </Button>
              {/* <span
             className="logout"
             onClick={() => {
               dispatch(logout(navigate));
             }}
           >
             Wyloguj się
           </span> */}
            </div>
            <div className="disclaimers">
              <p className="disclaimer">
                Szczegółowe informacje znajdziesz w{" "}
                <a
                  href="https://www.hurt.batpartners.pl/pdf/klauzula_informacy_na_bp_hurt.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Regulaminie programu.
                </a>{" "}
              </p>
              <p className="disclaimer">
                Więcej informacji o tym, jakie dane zbieramy, w jakim celu oraz
                do czego je wykorzystujemy, znajdziesz w
                <a
                  href="https://www.hurt.batpartners.pl/pdf/klauzula_informacy_na_bp_hurt.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  &nbsp;Klauzuli Informacyjnej.
                </a>
              </p>
              <p className="disclaimer">
                Wycofanie zgody nie będzie miało jednak wpływu na zgodność
                z&nbsp;prawem działań podjętych jeszcze przed jej wycofaniem.
              </p>
            </div>
          </div>
        )}
        {step === 1 && (
          <div className="consent-inner step-1">
            <div className="image">
              <img src={topBg02} alt="Consent" />
            </div>
            <h2>Dziękujemy za korzystanie z&nbsp;naszego&nbsp;programu.  </h2>
            <p className="description">
            Nie zaakceptowałeś(-aś) regulaminu nowej edycji programu, dlatego Twoje konto zostało dezaktywowane i&nbsp;nie bierze udziału w edycji programu 2025.
            </p>
            <p className="description">
            Dane osobowe oraz informacje podatkowe (PIT) zebrane w&nbsp;ramach edycji programu z&nbsp;2024&nbsp;roku będą nadal przetwarzane wyłącznie w celach podatkowych i&nbsp;rozliczeniowych, zgodnie z obowiązującymi przepisami prawa. Nie mają one związku z&nbsp;bieżącą edycją programu.
            </p>
            <p className="disclaimer">
            Więcej informacji na temat zakresu i celu przetwarzania<br/> danych znajdziesz w naszej&nbsp;
              <a
                href="https://www.hurt.batpartners.pl/pdf/klauzula_informacy_na_bp_hurt.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Klauzuli Informacyjnej.
              </a>{" "}
            </p>

            <div className="btn-group">
              <Button
                onClick={() => {
                  dispatch(logout(navigate));
                }}
              >
                Wyloguj
              </Button>
              {/* <span
             className="logout"
             onClick={() => {
               dispatch(logout(navigate));
             }}
           >
             Wyloguj się
           </span> */}
            </div>
          </div>
        )}
      </div>
    </PageLayout>
  );
}

export default Consent;
